import { render } from "./SettingsTable.vue?vue&type=template&id=6783238d"
import script from "./SettingsTable.vue?vue&type=script&lang=js"
export * from "./SettingsTable.vue?vue&type=script&lang=js"

import "./SettingsTable.vue?vue&type=style&index=0&id=6783238d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__